import React from "react";
import Logo from "../Images/image.84a44b7bd2e4fc988ba0.png";
const Header = () => {
  return (
    <div className="header">
      <img src={Logo} alt="Covid-Logo" className="app_logo" />
    </div>
  );
};

export default Header;
